// extracted by mini-css-extract-plugin
export default {"wrapper":"iwebV2PjPTwzBL3v578z"};